<mat-dialog-content
  class="dialog-container"
  [class.dialog-container--unpadded]="showEventPicker() || showProviderChooser()">
  @if (showProviderChooser()) {
    <ninety-choose-calendar-provider-dialog
      [integrations]="providerChooserIntegrations()"
      (closed)="onProviderChooserClosed()" />
  } @else if (!showEventPicker()) {
    <div class="header-container" *ngrxLet="{ currentTeam: currentTeam$, language: language$ } as vm">
      <div class="flex-justify-space-between">
        <h1 class="terra-title">Start {{ vm.language.meeting.item }}</h1>
        <ninety-button flat icon mat-dialog-close>
          <terra-icon icon="x" />
        </ninety-button>
      </div>
      <p class="text-light sub-header">Select an agenda for your {{ vm.language.meeting.item | lowercase }}</p>
    </div>
    <ninety-meeting-bot-calendar-section
      dataCyPrefix="start-meeting-dialog"
      [addMeetingAgentControl]="addMeetingAgentControl"
      [pickedEvent]="selectedCalendarEvent()"
      (openPicker)="openEventPicker()"
      (openProviderChooser)="onOpenProviderChooser($event)">
      @if (!selectedCalendarEvent()) {
        <span class="text-light meeting-link-divider">or</span>
        <terra-form-field class="meeting-link-field">
          <terra-form-label>
            Add conference link
            <span class="_terra-migration-approved-override--terra-form-optional">(optional)</span>
          </terra-form-label>
          <terra-text-input
            placeholder="https://zoom.us/j/..."
            data-cy="start-meeting-dialog_meeting-link-input"
            [formControl]="meetingLinkControl">
            @if (meetingLinkControl.valid && meetingLinkControl.value) {
              <terra-input-suffix>
                <terra-icon
                  class="meeting-link-valid-icon"
                  icon="check-circle"
                  variant="fill"
                  data-cy="start-meeting-dialog_meeting-link-valid-icon" />
              </terra-input-suffix>
            }
          </terra-text-input>
          @if (meetingLinkControl.invalid && meetingLinkControl.touched) {
            <terra-error data-cy="start-meeting-dialog_meeting-link-error">
              @if (meetingLinkControl.errors?.unsupportedPlatform) {
                Enter a valid Zoom, Google Meet, Microsoft Teams, Webex, or GoToMeeting link
              } @else {
                Enter a valid URL
              }
            </terra-error>
          }
        </terra-form-field>
      }
    </ninety-meeting-bot-calendar-section>
    <ng-container *ngrxLet="recentMeetings$ as recentMeetings">
      @if (recentMeetings.length > 0) {
        <span class="header">Recently run</span>
        @for (meeting of recentMeetings; track meeting) {
          <div
            class="menu-item"
            (click)="createMeeting(meeting.type, meeting.agendaId)"
            attr.data-cy="create-recent-meeting_{{ meeting.type }}_{{ meeting.agendaId }}">
            <terra-icon class="text-lightest" icon="calendar" />
            <span class="flex-2">{{ meeting.agendaName }}</span>
            <span class="text-light">{{ meeting.date | dateDistance }}</span>
            <span class="start-meeting-label">Start</span>
          </div>
        }
        <terra-divider height="short" class="recent-meetings-divider" />
      }
    </ng-container>

    <span class="header">All agendas</span>
    @for (meeting of defaultMeetings$ | async; track meeting) {
      <div class="menu-item" (click)="createMeeting(meeting.id)" attr.data-cy="create-default-meeting_{{ meeting.id }}">
        <terra-icon class="text-lightest" icon="calendar" />
        <span class="flex-2">{{ meeting.displayText }}</span>
        <span class="start-meeting-label">Start</span>
      </div>
    }
    @for (meeting of customMeetings$ | async; track meeting) {
      <div
        class="menu-item"
        (click)="createMeeting(meetingType.custom, meeting.id)"
        attr.data-cy="create-custom-meeting_{{ meeting.id }}">
        <terra-icon class="text-lightest" icon="calendar" />
        <span class="flex-2">{{ meeting.displayText }}</span>
        <span class="start-meeting-label">Start</span>
      </div>
    }
  } @else {
    <ninety-select-calendar-event-dialog
      [connectionId]="activeCalendarConnectionId()!"
      [calendarService]="calendarEventsService()"
      [selectedEventId]="selectedCalendarEvent()?.id"
      (closed)="onEventPickerClosed($event)" />
  }
</mat-dialog-content>
@if (!showEventPicker() && !showProviderChooser() && (canManageAgendas$ | async)) {
  <mat-dialog-actions align="start">
    <ninety-button compact primary (click)="manageAgendas()">Manage agendas...</ninety-button>
  </mat-dialog-actions>
}
